var _style, _path, _path2, _line, _line2, _line3, _path3, _line4, _line5, _line6, _line7, _line8, _line9, _line0, _ellipse, _line1, _ellipse2, _line10, _ellipse3, _path4, _path5, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgNodeBodyBottom = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  id: "NodeBodyBottom",
  x: "0px",
  y: "0px",
  viewBox: "0 0 320 140",
  style: {
    enableBackground: "new 0 0 320 140"
  },
  xmlSpace: "preserve",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
  type: "text/css"
}, "\r\n\t.stv0{fill:#071F33;}\r\n\t.stv1{fill:none;stroke:#071F33;stroke-width:2;stroke-miterlimit:10;}\r\n\t.stv2{fill:none;stroke:#50AD70;stroke-width:2;stroke-miterlimit:10;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
  className: "stv0",
  d: "M95.2,52.7H43.4c-3.4,0-6.1,2.8-6.1,6V93c0,3.3,2.7,6,6.1,6h51.8c3.4,0,6.1-2.8,6.1-6V58.7 C101.3,55.4,98.6,52.7,95.2,52.7z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  className: "stv0",
  d: "M260.6,52.7h-51.8c-3.4,0-6.1,2.8-6.1,6V93c0,3.3,2.7,6,6.1,6h51.8c3.4,0,6.1-2.8,6.1-6V58.7 C266.7,55.4,264,52.7,260.6,52.7z"
})), _line || (_line = /*#__PURE__*/React.createElement("line", {
  className: "stv1",
  x1: 225.8,
  y1: 98.3,
  x2: 225.8,
  y2: 122
})), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
  className: "stv1",
  x1: 232.4,
  y1: 98.3,
  x2: 232.4,
  y2: 122
})), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
  className: "stv1",
  x1: 239.4,
  y1: 98.3,
  x2: 239.4,
  y2: 122
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  className: "stv0",
  d: "M177.9,52.7h-51.8c-3.4,0-6.1,2.8-6.1,6V93c0,3.3,2.7,6,6.1,6h51.8c3.4,0,6.1-2.8,6.1-6V58.7 C184,55.4,181.3,52.7,177.9,52.7z"
})), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
  className: "stv1",
  x1: 139.8,
  y1: 98.3,
  x2: 139.8,
  y2: 122
})), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
  className: "stv1",
  x1: 146.4,
  y1: 98.3,
  x2: 146.4,
  y2: 122
})), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
  className: "stv1",
  x1: 153.4,
  y1: 98.3,
  x2: 153.4,
  y2: 122
})), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
  className: "stv1",
  x1: 71.8,
  y1: 98.3,
  x2: 71.8,
  y2: 122
})), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
  className: "stv1",
  x1: 78.4,
  y1: 98.3,
  x2: 78.4,
  y2: 122
})), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
  className: "stv1",
  x1: 85.4,
  y1: 98.3,
  x2: 85.4,
  y2: 122
})), _line0 || (_line0 = /*#__PURE__*/React.createElement("line", {
  className: "stv1",
  x1: 59.4,
  y1: 52.8,
  x2: 59.4,
  y2: 29.5
})), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
  className: "stv2",
  cx: 59.4,
  cy: 26.7,
  rx: 2.9,
  ry: 2.9
})), _line1 || (_line1 = /*#__PURE__*/React.createElement("line", {
  className: "stv1",
  x1: 225.8,
  y1: 52.8,
  x2: 225.8,
  y2: 29.5
})), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
  className: "stv2",
  cx: 225.8,
  cy: 26.7,
  rx: 2.9,
  ry: 2.9
})), _line10 || (_line10 = /*#__PURE__*/React.createElement("line", {
  className: "stv1",
  x1: 139.8,
  y1: 52.8,
  x2: 139.8,
  y2: 29.5
})), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
  className: "stv2",
  cx: 139.8,
  cy: 26.7,
  rx: 2.9,
  ry: 2.9
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  className: "stv1",
  d: "M298.1,285.3"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  className: "stv1",
  d: "M298.1,283.6"
})), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "stv1",
  d: "M59.4,97.1v16c-0.7,10,8.9,8.4,8.9,8.4h12.6h210.7c4.1,0,4.3,4.4,4.3,4.4v14.3"
}))));
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgNodeBodyBottom, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/NodeBodyBottom.1b582001.svg";
export { ForwardRef as ReactComponent };